import(/* webpackMode: "eager" */ "/tmp/build_f4fe667f/apps/sales-pilot-sites/src/app/global-error.tsx");
